// Validated same-site return path for post-login redirects.
// The path travels in the URL (?next=), so it survives reloads, Google sign-in and email confirmation links.
export function sanitizeNext(n: string | null | undefined): string | null {
  if (!n) return null;
  if (!n.startsWith('/') || n.startsWith('//') || n.includes('\\')) return null;
  if (/^\/auth(\/|\?|#|$)/.test(n)) return null; // avoid loops
  return n;
}

export function safeNext(search = window.location.search): string {
  const p = new URLSearchParams(search);
  return sanitizeNext(p.get('next')) ?? sanitizeNext(p.get('redirect')) ?? '/';
}

/** Sign-in page URL that returns to the current page afterwards. */
export function authUrl(next = window.location.pathname + window.location.search) {
  return `/auth?next=${encodeURIComponent(next)}`;
}
